<template>
  <div @click="openModal" :class="cardClasses" class="card cursor-pointer mb-2 flex items-center relative justify-start">
    <div class="badge badge-light absolute top-0 left-0">Neue Reihenfolge: {{ index + 1 }} / Aktuelle Reihenfolge: {{ question.order }}</div>
    <i class="fa-solid fa-grip-vertical mr-4"></i>
    <div class="question__content mr-4">
      <p :class="{'text-sm no-m' : sortingMode}" class="font-medium text-secondary-500 mb-2">{{ questionText }}</p>
      <p :class="{'hidden' : sortingMode}" class="text-sm text-gray-500">{{ __('question.type.' + question.type ) }}</p>
    </div>

    <i :class="{'hidden' : sortingMode}" class="fa fa-edit ml-auto"></i>
  </div>
</template>

<script>

export default {
  name: 'QuestionListItem',

  props: {
    index: {
      type: Number,
      required: false,
    },
    question: {
      type: Object,
      required: true,
    },
    sortingMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    changed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    questionText: function() {
      return this.sortingMode ? this.question.text : this.question.text.substring(0, 50) + '...'
    },

    cardClasses: function() {
      return [
        this.sortingMode ? 'sorting-mode' : '',
        this.index + 1  != this.question.order ? 'bg-orange-100' : '',
      ]
    },
  },

  methods: {
    openModal: function() {
      this.$emit('open-modal', this.question )
    },
  },
}
</script>

<style scoped>
.sorting-mode {
  padding: 20px 0 10px 15px !important;
}
.hidden {
  display: none !important;
}
.no-m {
  margin: 0 !important;
}
</style>